// GENERATED by scripts/i18n.ts from src/i18n/messages/{hotkeys,shell,sign-in}.csv. Do not edit; edit the table and run `npm run i18n`.
import type { messages as controls } from "./bundles/controls.gen";
import type { messages as kitPage } from "./bundles/kit-page.gen";
import type { messages as patients } from "./bundles/patients.gen";
import type { messages as search } from "./bundles/search.gen";
import type { messages as settings } from "./bundles/settings.gen";
import type { messages as units } from "./bundles/units.gen";

export const LOCALES = ["en","zh-HK"] as const;
export type Locale = (typeof LOCALES)[number];

/** The first-paint tables, in the i18n instance from the start. */
export const resources = {
  "en": { translation: {
    "hotkey.search": "search everything",
    "hotkey.primary": "the screen's primary action",
    "hotkey.tab": "between fields and controls · ⇧ goes back",
    "hotkey.searchBox": "search this screen or open search",
    "hotkey.escape": "leave the box · close what is open",
    "hotkey.sheet": "this list",
    "hotkey.listMove": "move down the list",
    "hotkey.listEnds": "the first row · the last row · or {{mod}}↑ {{mod}}↓",
    "hotkey.listOpen": "open the row you are on",
    "hotkey.sheetTitle": "What you can press",
    "hotkey.sheetDoor": "Keyboard shortcuts",
    "hotkey.group.screen": "This screen",
    "hotkey.group.list": "Lists",
    "hotkey.group.everywhere": "Everywhere",
    "hotkey.notNow": "not just now",
    "hotkey.noneHere": "This screen has no keys of its own.",
    "hotkey.edit": "edit this record",
    "hotkey.tabs": "the tabs across this screen",
    "hotkey.hire": "create an account",
    "hotkey.editBranch": "edit the branch on this row",
    "hotkey.settings": "open Settings",
    "hotkey.nav.home": "open Dashboard",
    "hotkey.nav.patients": "open Patients",
    "hotkey.nav.dispense": "open Dispensing",
    "hotkey.nav.pos": "open the POS",
    "hotkey.nav.inventory": "open Inventory",
    "hotkey.nav.catalogue": "open Catalogue",
    "hotkey.nav.reports": "open Reports",
    "hotkey.nav.settings": "open Settings",
    "hotkey.nav.doors": "the doors across the top bar",
    "hotkey.addRole": "add a role",
    "hotkey.editAccess": "edit access rights",
    "hotkey.addPatient": "add a patient",
    "app.name": "PharmOS",
    "app.skipToContent": "Skip to content",
    "app.search": "Search",
    "app.searchTitle": "Search screens ({{key}})",
    "app.hotkeys": "Keyboard shortcuts",
    "app.hotkeysTitle": "Keyboard shortcuts (?)",
    "app.branchChosenAtSignIn": "Company and branch are chosen at sign-in.",
    "app.changePassword": "Change password",
    "app.yourAccount": "Your account",
    "app.language": "Language",
    "app.screenLayout": "Screen layout",
    "app.preferenceNotSaved": "Not saved to your account.",
    "app.cancel": "Cancel",
    "app.close": "Close",
    "ui.unsaved.title": "Unsaved changes",
    "ui.unsaved.save": "Save changes",
    "ui.unsaved.discard": "Don't save",
    "ui.unsaved.saving": "Saving…",
    "app.noAccess": "You do not have access to this.",
    "app.mockUnavailable": "The mock server did not start. This build cannot run without it.",
    "nav.home": "Dashboard",
    "nav.dispense": "Dispensing",
    "nav.pos": "POS",
    "nav.inventory": "Inventory",
    "nav.catalogue": "Catalogue",
    "nav.patients": "Patients",
    "nav.reports": "Reports",
    "nav.settings": "Settings",
    "vocab.module.counter": "Retail & Rx",
    "vocab.module.psp": "Sponsored programme",
    "vocab.module.cpms": "Government programme",
    "vocab.moduleShort.counter": "Retail",
    "vocab.moduleShort.psp": "Sponsor",
    "vocab.moduleShort.cpms": "Govt",
    "vocab.view.browser": "Browser view",
    "vocab.view.grid": "Windows grid view",
    "vocab.edition.full": "Full version",
    "vocab.edition.simple": "Simple version",
    "vocab.locale.en": "English",
    "vocab.locale.zh-HK": "繁體中文",
    "state.loading": "Loading",
    "state.notFound.title": "Page not found",
    "state.notFound.action": "Go to the home page",
    "state.pending.title": "Not built yet",
    "state.pending.body": "This screen is built when its API is delivered.",
    "auth.signIn": "Sign in",
    "auth.signOut": "Sign out",
    "auth.platformTagline": "One pharmacy platform",
    "auth.headlineOne": "The POS. The bench. The shelf.",
    "auth.headlineTwo": "One place to stand.",
    "auth.platformLede": "Retail sales, dispensing and stock share one patient record, one stock ledger and one POS.",
    "auth.branchesYouMayEnter": "Branches you may enter: {{n}}",
    "auth.footerTagline": "Retail sales and dispensing on one platform",
    "auth.welcomeBack": "Welcome back",
    "auth.beginShift": "Sign in to begin your shift",
    "auth.companyId": "Company ID",
    "auth.staffId": "Staff ID",
    "auth.password": "Password",
    "auth.showPassword": "Show password",
    "auth.hidePassword": "Hide password",
    "auth.signingIn": "Signing in…",
    "auth.credentialShape": "Enter {{min}}–{{max}} characters.\nAt least three of: capital, small letter, number, symbol.\nOr enter the {{pin}}-digit one-time password.",
    "auth.attemptsRemaining": "Attempts remaining: {{n}}.",
    "auth.failedAttempts": "Failed attempts: {{n}}",
    "auth.accountLocked": "Account locked",
    "auth.accountLockedRefusal": "Account locked. Contact your branch admin.",
    "auth.lockedRemedy": "Contact your branch admin to unlock this account.",
    "auth.newPasswordTitle": "Set your password",
    "auth.newPasswordLede": "The one-time password you signed in with is used up. Choose the password you will sign in with from now on.",
    "auth.currentPassword": "Current password",
    "auth.passwordChanged": "Your password has been changed.",
    "auth.newPassword": "New password",
    "auth.confirmPassword": "Confirm new password",
    "auth.passwordRule": "{{min}}–{{max}} characters.\nAt least three of: capital, small letter, number, symbol.",
    "auth.passwordsDiffer": "The two entries do not match.",
    "auth.setPasswordAndContinue": "Set password and continue",
    "auth.saving": "Saving…",
    "auth.back": "Back",
    "auth.signedInAs": "Signed in as",
    "auth.switchAccount": "Switch account",
    "auth.company": "Company",
    "auth.branch": "Branch",
    "auth.onlyBranch": "The only branch under this company.",
    "auth.chooseBranch": "Choose your branch",
    "auth.workingAs": "Working as",
    "auth.pickBranchFirst": "Pick a branch first.",
    "auth.roleNotStated": "Not stated",
    "auth.assigned": "ASSIGNED",
    "auth.enterWorkspace": "Enter workspace",
    "auth.signInExpired": "This sign-in has expired. Enter your company id, staff id and password again.",
    "auth.branchExchangeUncertain": "The server took too long to confirm the branch. Start sign-in again rather than repeating this step.",
    "auth.startAgain": "Start again",
    "auth.noBranchTitle": "No branch to sign in at",
    "auth.noBranchLede": "This account holds no group at any branch. Ask an administrator to grant one."
  } },
  "zh-HK": { translation: {
    "hotkey.search": "搜尋全部",
    "hotkey.primary": "本畫面的主要操作",
    "hotkey.tab": "在欄位與控制項之間移動 · ⇧ 返回上一個",
    "hotkey.searchBox": "搜尋本畫面或開啟搜尋",
    "hotkey.escape": "離開輸入框 · 關閉開啟中的視窗",
    "hotkey.sheet": "本列表",
    "hotkey.listMove": "在清單中移動",
    "hotkey.listEnds": "第一列 · 最後一列 · 或 {{mod}}↑ {{mod}}↓",
    "hotkey.listOpen": "開啟目前的一列",
    "hotkey.sheetTitle": "可按的按鍵",
    "hotkey.sheetDoor": "鍵盤快捷鍵",
    "hotkey.group.screen": "本畫面",
    "hotkey.group.list": "清單",
    "hotkey.group.everywhere": "任何畫面",
    "hotkey.notNow": "暫時不適用",
    "hotkey.noneHere": "本畫面沒有專屬按鍵。",
    "hotkey.edit": "編輯此紀錄",
    "hotkey.tabs": "本畫面的分頁",
    "hotkey.hire": "建立帳戶",
    "hotkey.editBranch": "編輯此列分店",
    "hotkey.settings": "開啟設定",
    "hotkey.nav.home": "開啟主頁",
    "hotkey.nav.patients": "開啟病人",
    "hotkey.nav.dispense": "開啟配藥",
    "hotkey.nav.pos": "開啟收銀",
    "hotkey.nav.inventory": "開啟存貨",
    "hotkey.nav.catalogue": "開啟目錄",
    "hotkey.nav.reports": "開啟報表",
    "hotkey.nav.settings": "開啟設定",
    "hotkey.nav.doors": "頂欄上的各個入口",
    "hotkey.addRole": "新增角色",
    "hotkey.editAccess": "編輯存取權限",
    "hotkey.addPatient": "新增病人",
    "app.name": "PharmOS",
    "app.skipToContent": "跳至內容",
    "app.search": "搜尋",
    "app.searchTitle": "搜尋畫面（{{key}}）",
    "app.hotkeys": "鍵盤快速鍵",
    "app.hotkeysTitle": "鍵盤快速鍵（?）",
    "app.branchChosenAtSignIn": "公司及分店於登入時選定。",
    "app.changePassword": "更改密碼",
    "app.yourAccount": "你的帳戶",
    "app.language": "語言",
    "app.screenLayout": "畫面版面",
    "app.preferenceNotSaved": "未儲存至你的帳戶。",
    "app.cancel": "取消",
    "app.close": "關閉",
    "ui.unsaved.title": "未儲存的更改",
    "ui.unsaved.save": "儲存更改",
    "ui.unsaved.discard": "不儲存",
    "ui.unsaved.saving": "儲存中…",
    "app.noAccess": "你沒有此項權限。",
    "app.mockUnavailable": "模擬伺服器未能啟動，此版本無法運作。",
    "nav.home": "主頁",
    "nav.dispense": "配藥",
    "nav.pos": "收銀",
    "nav.inventory": "存貨",
    "nav.catalogue": "目錄",
    "nav.patients": "病人",
    "nav.reports": "報表",
    "nav.settings": "設定",
    "vocab.module.counter": "零售及處方",
    "vocab.module.psp": "資助計劃",
    "vocab.module.cpms": "政府計劃",
    "vocab.moduleShort.counter": "零售",
    "vocab.moduleShort.psp": "資助",
    "vocab.moduleShort.cpms": "政府",
    "vocab.view.browser": "瀏覽器版面",
    "vocab.view.grid": "視窗表格版面",
    "vocab.edition.full": "完整版",
    "vocab.edition.simple": "簡易版",
    "vocab.locale.en": "English",
    "vocab.locale.zh-HK": "繁體中文",
    "state.loading": "載入中",
    "state.notFound.title": "找不到頁面",
    "state.notFound.action": "返回主頁",
    "state.pending.title": "尚未建立",
    "state.pending.body": "此畫面將於其 API 提供後建立。",
    "auth.signIn": "登入",
    "auth.signOut": "登出",
    "auth.platformTagline": "一站式藥房平台",
    "auth.headlineOne": "收銀。配藥。貨架。",
    "auth.headlineTwo": "所需一切，盡在一處。",
    "auth.platformLede": "零售、配藥、存貨共用一份病人記錄、一本存貨帳、一個收銀台。",
    "auth.branchesYouMayEnter": "可進入 {{n}} 間分店",
    "auth.footerTagline": "零售及配藥，同一平台",
    "auth.welcomeBack": "歡迎回來",
    "auth.beginShift": "登入以開始輪班",
    "auth.companyId": "公司編號",
    "auth.staffId": "員工編號",
    "auth.password": "密碼",
    "auth.showPassword": "顯示密碼",
    "auth.hidePassword": "隱藏密碼",
    "auth.signingIn": "登入中…",
    "auth.credentialShape": "請輸入 {{min}}–{{max}} 個字符。\n大寫、小寫、數字、符號至少三項。\n或輸入 {{pin}} 位一次性密碼。",
    "auth.attemptsRemaining": "尚餘嘗試次數：{{n}}。",
    "auth.failedAttempts": "失敗嘗試次數：{{n}}",
    "auth.accountLocked": "帳戶已鎖定",
    "auth.accountLockedRefusal": "帳戶已被鎖定。請聯絡分店管理員。",
    "auth.lockedRemedy": "請聯絡分店管理員解除鎖定。",
    "auth.newPasswordTitle": "設定您的密碼",
    "auth.newPasswordLede": "您用作登入的一次性密碼已失效。請設定日後登入所用的密碼。",
    "auth.currentPassword": "目前密碼",
    "auth.passwordChanged": "密碼已更改。",
    "auth.newPassword": "新密碼",
    "auth.confirmPassword": "確認新密碼",
    "auth.passwordRule": "{{min}}–{{max}} 個字符。\n大寫、小寫、數字、符號，至少三項。",
    "auth.passwordsDiffer": "兩次輸入的密碼不相同。",
    "auth.setPasswordAndContinue": "設定密碼並繼續",
    "auth.saving": "儲存中…",
    "auth.back": "返回",
    "auth.signedInAs": "已登入",
    "auth.switchAccount": "切換帳戶",
    "auth.company": "公司",
    "auth.branch": "分店",
    "auth.onlyBranch": "此公司旗下唯一分店。",
    "auth.chooseBranch": "選擇分店",
    "auth.workingAs": "本更身分",
    "auth.pickBranchFirst": "請先選擇分店。",
    "auth.roleNotStated": "未有說明",
    "auth.assigned": "已指派",
    "auth.enterWorkspace": "進入工作區",
    "auth.signInExpired": "此次登入已逾時。請重新輸入公司編號、員工編號及密碼。",
    "auth.branchExchangeUncertain": "伺服器未能及時確認分店。請重新登入，不要重複此步驟。",
    "auth.startAgain": "重新登入",
    "auth.noBranchTitle": "沒有可登入的分店",
    "auth.noBranchLede": "此帳戶在所有分店均未獲分配群組，請聯絡管理員。"
  } },
} as const;

/** Every key of every table, including the bundles that load with their code. */
export type Messages = (typeof resources)["en"]["translation"] &
  (typeof controls)["en"] &
  (typeof kitPage)["en"] &
  (typeof patients)["en"] &
  (typeof search)["en"] &
  (typeof settings)["en"] &
  (typeof units)["en"];
export type MessageKey = keyof Messages;
